import {
  Box,
  Button,
  Card,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ButtonText, H6, Small } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
// ----------------------------------
import insta from 'assets/fab-insta.png';
import naver from 'assets/fab-naver.png';
import youtube from 'assets/fab-youtube.png';
import blog from 'assets/naver-blog.svg';
// ----------------------------------

const Footer = ({ showSideBar, darkMode }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const { t } = useTranslation();

  const location = useLocation();
  let sidebarWidth = '0px';
  // let sidebarWidth = "230px";

  switch (location.pathname) {
    case '/naver/landing':
      sidebarWidth = '0px';
      break;
  }

  // styled components
  const StyledCard = styled(Card)(({ theme, showSideBar, darkMode }) => ({
    width: `calc(100% - ${
      isTablet ? '0px' : showSideBar ? sidebarWidth : '0px'
    })`,
    marginLeft: isTablet ? '0px' : showSideBar ? sidebarWidth : '0px',
    backgroundColor: darkMode ? theme.palette.primary.dark : '#EAEAEA',
    color: darkMode ? '#FFFFFF' : '#151515',
    borderRadius: 0,
    border: 'none',
    zIndex: 10,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  const navLinksRow1 = [
    '공지사항',
    '강사 지원하기',
    '자주 묻는 질문',
    '서비스 이용약관',
  ];
  const navLinksRow2 = ['개인정보처리방침', '저작권 안내', '채용'];
  const navLinksRow3 = [
    { title: '네이버 블로그', image: blog },
    { title: 'Youtube', image: youtube },
  ];
  const navLinksRow4 = [
    { title: '네이버 카페', image: naver },
    { title: '인스타그램', image: insta },
  ];

  return (
    <StyledCard showSideBar={showSideBar} darkMode={darkMode}>
      <Grid
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: { xs: '2rem 2rem', lg: '2rem 4rem' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        {/* first and second menu */}
        <Grid
          xs={12}
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            flexDirection: { xs: 'row', lg: 'row' },
            marginBottom: { xs: 4, lg: 0 },
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            sx={{
              flexBasis: { xs: '100%', lg: '48%' },
            }}
          >
            {navLinksRow1.map((link, index) => (
              <Grid item key={index}>
                <H6>
                  <NavLink
                    to={`/${link}`}
                    style={{ color: darkMode ? '#FFFFFF' : '#151515' }}
                  >
                    {link}
                  </NavLink>
                </H6>
              </Grid>
            ))}
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            sx={{
              flexBasis: { xs: '100%', lg: '48%' },
            }}
          >
            {navLinksRow2.map((link, index) => (
              <Grid item key={index}>
                <H6>
                  <NavLink
                    to={`/${link}`}
                    style={{ color: darkMode ? '#FFFFFF' : '#151515' }}
                  >
                    {link}
                  </NavLink>
                </H6>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* third and fourth menu */}
        <Grid
          xs={12}
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            flexDirection: { xs: 'row', lg: 'row' },
            marginBottom: { xs: 4, lg: 0 },
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            sx={{
              flexBasis: { xs: '100%', lg: '48%' },
            }}
          >
            {navLinksRow3.map((item, image, index) => (
              <Grid item key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={item.image}
                    alt={'icon'}
                    width={20}
                    style={{ marginRight: '4px', objectFit: 'contain' }}
                  />
                  <H6>
                    <NavLink
                      to={`/${item.title}`}
                      style={{ color: darkMode ? '#FFFFFF' : '#151515' }}
                    >
                      {item.title}
                    </NavLink>
                  </H6>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            sx={{
              flexBasis: { xs: '100%', lg: '48%' },
            }}
          >
            {navLinksRow4.map((item, image, index) => (
              <Grid item key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={item.image}
                    alt={'icon'}
                    width={20}
                    style={{ marginRight: '4px', objectFit: 'contain' }}
                  />
                  <H6>
                    <NavLink
                      to={`/${item.title}`}
                      style={{ color: darkMode ? '#FFFFFF' : '#151515' }}
                    >
                      {item.title}
                    </NavLink>
                  </H6>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ minWidth: isTablet ? 'inherit' : 350, width: '100%' }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            {/* <Box> */}
            <Button
              variant="contained"
              size="small"
              sx={{
                width: '100%',
                borderRadius: 2,
                background: darkMode
                  ? '#2D2D2E'
                  : theme.palette.gradient.purpletoblue,
                color: '#FFFFFF',
              }}
            >
              <ButtonText>문의하기</ButtonText>
            </Button>
            {/* <Small> */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: isTablet ? 'column' : 'row',
                justifyContent: 'center',
              }}
            >
              <Small
                style={{
                  textAlign: 'center',
                  color: darkMode ? '#FFFFFF' : '#151515',
                  fontWeight: 400,
                  marginRight: '6px',
                }}
              >
                {t('평일 10:00 - 18:00')}
              </Small>
              {/* </Small> */}
              <Small>{t('점심시간 12 - 13시 | 주말 및 공휴일 제외')}</Small>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          width: '100%',
          padding: { xs: '0rem 2rem', lg: '0rem 4rem' },
        }}
      >
        <Box
          sx={{
            borderTop: `1px solid ${darkMode ? '#555555' : '#CBCBCB'}`,
            padding: '1rem 0rem 2rem 0rem',
          }}
        >
          <Small lineHeight={1} sx={{ lineHeight: 1 }}>
            {'슈가컴퍼니(주) 대표 \n 사무실 서울시 서초구 사임당로 143, 크로스 143타워 2층 | 교육장 서울시 강남구 역삼로 134, MS빌딩 2층 | 사업자등록번호 321-86-00842 사업자정보확인 통신판매업신고번호 제2018-서울강남-03590호 개인정보관리책임자 성주엽'
              .split('\n')
              .map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
          </Small>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default Footer;
